import React from 'react';

// Keep a render failure recoverable in the native shell. Do not include account
// data or raw error messages in logs; remote reporting needs a separate setup.
export default class AppErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch() { console.error('TapTap could not render its current screen.'); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="flex min-h-screen items-center justify-center bg-slate-950 p-6 text-white">
        <div role="alert" className="max-w-sm text-center">
          <h1 className="text-xl font-bold">Let’s try opening TapTap again</h1>
          <p className="mt-3 text-sm text-slate-300">This screen couldn’t load. Reloading may lose progress that hasn’t been saved yet.</p>
          <button type="button" onClick={() => window.location.reload()} className="mt-6 min-h-11 rounded-xl bg-indigo-600 px-6 py-3 font-semibold">Reload TapTap</button>
        </div>
      </main>
    );
  }
}
